<form #form="ngForm">
    <div class="transport-details">
        <app-as2-transport-viewer name="as2-transport" [ngModel]="value()" (ngModelChange)="updateTransport($event)" [disabled]="disabled()" required></app-as2-transport-viewer>
    </div>
</form>